import React, { useState, useEffect } from 'react'

import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    TextField,
    Typography,
    CircularProgress
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'

import NumberFormat from 'react-number-format'

import { useSelector, useDispatch } from 'react-redux'
import { showError, createItem } from '../../../actions/misc/misc.actions'

const useStyles = makeStyles((theme) => ({
    title: {
        // marginBottom: 24
        paddingBottom: 0
    },
    dialogActions: {
        justifyContent: 'flex-start',
        padding: 24
    },
    fieldWrapper: {
        minWidth: '400px !important',
        width: '400px !important',
        marginBottom: 20,
        '& .MuiFilledInput-root': {
            minWidth: '400px !important',
            width: '400px !important'
        },
        '& .MuiTextField-root': {
            minWidth: '400px !important',
            width: '400px !important'
        }
    },
    charge: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingBottom: 6
    }
}))



const RetryChargeDialog = ({ setIsShown, isShown, charges, retryCharge, chargeError, loading }) => {
    const classes = useStyles()
    const dispatch = useDispatch()


    const closeDialog = () => {
        setIsShown(false)
    }

    const renderDescription = (data) => {
		let credits

		if (data.daycareCredits && data.daycareCredits.length > 0) {
			credits = data.daycareCredits
		}

		if (data.playcareCredits && data.playcareCredits.length > 0) {
			credits = data.playcareCredits
		}

		if (data.walkCredits && data.walkCredits.length > 0) {
			credits = data.walkCredits
		}

		let isMembershipCharge = data.type === 'autorenew' || data.type === 'membership' || data.description?.toLowerCase().includes('member')

		if (isMembershipCharge) return (
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<Typography className={classes.appointmentTitle}>Skiptown Membership Charge</Typography>
				<Typography className={classes.appointmentDescription}>{data.subtext || data.description}</Typography>
			</div>
		)

		return (
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				
				{(!credits && data.description) ||
					(credits && credits.length > 0 && !credits[0].discount && data.description) ? (
					<Typography className={classes.appointmentDescription}>{data.description}</Typography>
				) : null}
				{
					data.type === 'petcare_cancellation' && <Typography className={classes.appointmentDescription}>Cancellation Fee</Typography>
				}
				
				{
					data.subtext && <Typography className={classes.appointmentDescription}>{data.subtext}</Typography>
				}
			</div>
		)
	}

    const getCreditsTitle = (credit) => {
		let { type, bundle_size } = credit
		let isDaycare = type === 'daycare'
		let isPlaycare = type === 11

		return `${bundle_size} - ${isDaycare ? 'daycare' : isPlaycare ? 'playcare' : 'walk'} ${!isDaycare && !isPlaycare ? `bundle (${type} min visits)` : 'bundle'
			}`
	}

	const getAppointmentDate = (appointment) => {
		let date = appointment.visit_date ? moment(appointment.visit_date) : null
		let appointmentDetail = null

		if (date) {
			let day = date.format('D')
			let month = date.format('MMM')

			appointmentDetail = `${month} ${day}${appointment.appointment_type ? ` - ${appointment.appointment_type.name}` : null
				}`
		}

		return appointmentDetail
	}

	const getVisitDate = (visit) => {
		let start = visit.startDate ? moment(visit.startDate) : null
		let end = visit.endDate ? moment(visit.endDate) : moment(visit.startDate)

		if (start && end) {
			let startDay = start.format('D')
			let endDay = end.format('D')
			let startMonth = start.format('MMM')
			let endMonth = end.format('MMM')

			let endDateDisplay = ''

			if (visit.type === 'boarding') {
				endDateDisplay =
					startMonth === endMonth && endDay
						? ` - ${endDay}`
						: startMonth !== endMonth && endDay
							? ` - ${endMonth} ${endDay}`
							: null
			}

			return `${startMonth} ${startDay}${endDateDisplay}`
		}
	}

	const renderAmount = (data) => {
		let amount = data.amount / 100

		return data.type === 'Credit' || amount.toString().indexOf('-') !== -1 ? (
			<Typography className={classes.green}>
				{amount !== null ? `+ $${amount.toFixed(2).toString().substring(1)}` : 'No Amount'}
			</Typography>
		) : (
			<Typography className={classes.red}>${amount.toFixed(2)}</Typography>
		)
	}

    return (
        <Dialog
            open={isShown}
            aria-labelledby="form-dialog-title"
            className={classes.dialog}
            onClose={closeDialog}
            PaperProps={{
                style: {
                    minWidth: '648px',
                    maxWidth: '648px',
                    width: '648px',
                }
            }}>
            <DialogTitle className={classes.title}>RETRY CHARGES</DialogTitle>
            <DialogContent>
                <Typography variant="body1" style={{ marginBottom: 12 }}>
                    This action will re-try all of the following related charges:
                </Typography>
                {
                    chargeError && (
                        <Typography variant="body1" style={{ marginBottom: 12, color: '#DC2A2A' }}>
                            ERROR: {chargeError}
                        </Typography>
                    )
                }
                {
                    charges.map(data => {
                        return (
                            <div className={classes.charge}>
                                <div style={{ marginRight: 36 }}>
                                    <Typography variant="body1" className={classes.date}>

                                        {moment(data.createdAt).format('MMM DD, YYYY')}
                                    </Typography>
                                </div>
                                <div style={{ width: 250, marginRight: 12 }}>
                                    {
                                        data.title ? (
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography
                                                    className={classes.appointmentTitle}
                                                    style={{ color: data.type === 'member_dues' ? '#6B4AD6' : '#DC2A2A' }}>
                                                    {data.title}
                                                </Typography>
                                            </div>
                                        ) : (
                                            renderDescription(data)
                                        )
                                    }
                                </div>
                                <div>
                                    {renderAmount(data)}
                                </div>
                            </div>
                        )
                    })
                }

            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button variant="contained" color="secondary" onClick={() => retryCharge(charges)} style={{ height: 50 }} disabled={loading}>
                    {loading ?<CircularProgress/> : 'RETRY CHARGES'}
                </Button>
                <Button variant="outlined" color="secondary" onClick={closeDialog} style={{ height: 50 }} disabled={loading}>
                    CANCEL
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RetryChargeDialog
